import { render, staticRenderFns } from "./CompanyEmployeesTab.vue?vue&type=template&id=b1362f3c"
import script from "./CompanyEmployeesTab.vue?vue&type=script&lang=ts"
export * from "./CompanyEmployeesTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports